import { render, staticRenderFns } from "./form-product.vue?vue&type=template&id=43a1d9e8&scoped=true&"
import script from "./form-product.vue?vue&type=script&lang=js&"
export * from "./form-product.vue?vue&type=script&lang=js&"
import style0 from "./form-product.vue?vue&type=style&index=0&id=43a1d9e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a1d9e8",
  null
  
)

export default component.exports